// extracted by mini-css-extract-plugin
export default {"main":"c216c23aee","tit":"ae7535bb2a","maintitle":"cb96887f5a","ylw":"ed8a397895","white":"e009a35bc3","mv_title":"_9da885ea37","mv_nc":"d593aa2f86","mv_in":"_0781a4a30d"};